








































import { Vue, Component } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import CheckIcon from '@/components/icons/CheckGradient.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

type Slug = 'customer-import-feature' | 'merchant-app';
type FeedbackContent = {
  title: string;
  description: string;
  link: string;
  btnLabel: string;
};

@Component({
  components: {
    CheckIcon,
    Typography,
    FilledButton,
    Page
  }
})
export default class EmailFeedback extends Vue {
  mounted() {
    this.resizeEventHandler();

    window.addEventListener('resize', this.resizeEventHandler);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeEventHandler);
  }

  get tPrefix() {
    return 'emailFeedback';
  }

  get content() {
    const contentBySlug: Record<Slug, FeedbackContent> = {
      'customer-import-feature': {
        title: String(this.$t(`${this.tPrefix}.customerImport.title`)),
        description: String(
          this.$t(`${this.tPrefix}.customerImport.description`)
        ),
        btnLabel: String(this.$t(`${this.tPrefix}.customerImport.btnLabel`)),
        link: '/'
      },
      'merchant-app': {
        title: String(this.$t(`${this.tPrefix}.merchantAppInterest.title`)),
        description: String(
          this.$t(`${this.tPrefix}.merchantAppInterest.description`)
        ),
        btnLabel: String(
          this.$t(`${this.tPrefix}.merchantAppInterest.btnLabel`)
        ),
        link: '/'
      }
    };

    const slug = this.$route.params.slug as Slug;

    if (!contentBySlug[slug]) {
      return {
        title: 'Thank You for Your Feedback!',
        description:
          "Your input helps us improve, and we're excited to keep making things better for you!",
        btnLabel: 'Go to the Dashboard',
        link: '/'
      };
    }

    return contentBySlug[slug];
  }

  resizeEventHandler() {
    const vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty(
      '--email-feedback-vh',
      `${vh}px`
    );
  }
}
